import { ThemeProvider, createTheme } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux';
import { selectUser } from '../Redux/userSlice';
import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { bgLineGridColorDark, bgLineGridColorLight, corBgGrid, NFEntraItem, } from '../../Utils/Types';
import { RiEdit2Fill } from 'react-icons/ri';
import { FaTrashAlt } from 'react-icons/fa';

import { Tooltip } from 'react-tooltip'
import { Funcoes } from '../../Utils/Funcoes';

interface RowData {
    id: number,
    nitem: number,
    id_produto: number,
    descricao: string,
    desc_prod: string,
    qtd: number,
    unid_c: string,
    contem: number,
    vl_unit: number,
    vl_total: number,
    vl_tot: number,
    vl_desc: number,
    vl_seg: number,
    vl_out: number,
    vl_frete: number,
    vl_bc_pis: number,
    aliq_pis: number,
    vl_pis: number,
    cod_st_pis: string,
    vl_bc_cofins: number,
    aliq_cofins: number,
    vl_cofins: number,
    vl_bc_icms: number,
    aliq_icms: number,
    aliq_red_icms: number,
    vl_icms: number,
    vl_bc_ipi: number,
    aliq_ipi: number,
    vl_ipi: number,
    vl_bc_st: number,
    aliq_st: number,
    vl_st: number,
    mod_bc_st: number,
    pmvast: number,
    origem: number,
    cst_icms: string,
    cfop: string,
    indtot: number,
}

type Props = {
    produtos: NFEntraItem[],
    handleExcluirItem: (item: { nitem: number, desc_prod: string }) => void,
    handleEditarItem: (nitem: number) => void,
    btHabilitado:  boolean   
}

export const GridEntradaNotaItem = React.memo(({ produtos, handleExcluirItem, handleEditarItem, btHabilitado }: Props) => {

 
    let user = useSelector(state => selectUser(state));

    const theme = createTheme({
        palette: {
            mode: user.modeDark,

            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569',
            },
        },
    });

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'

    const columns = useMemo<MRT_ColumnDef<NFEntraItem>[]>(() => [

        {
            accessorKey: 'acao', header: 'Ações', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: ((cell: any) => {

                const rowData = cell.row.original as RowData;

                const handleExcluirClick = () => {

                    const timerExcluir = setTimeout(() => {

                        const dados = {
                            nitem: rowData.nitem,
                            desc_prod: rowData.desc_prod,
                        }
    
                        handleExcluirItem(dados)

                        clearTimeout(timerExcluir)
                    }, 0);

                }

                const handleEditarClick = () => {
                    handleEditarItem(rowData.nitem)
                }

                return (
                    <div className={`flex justify-start w-full`}>

                        <button
                            tabIndex={-1}
                            onClick={handleExcluirClick} data-tooltip-id={'tooltip-confirmar-' + rowData.id} id={'btn-confirmar-' + rowData.id}
                            className={`flex items-center justify-center 
                                        text-white transition-all duration-300 
                                        hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                        bg-red-500 `}
                            disabled={btHabilitado}
                        >

                            <FaTrashAlt size={'18px'} />
                        </button>
                        <Tooltip id={`tooltip-confirmar-${rowData.id}`} anchorSelect={'#btn-confirmar-' + rowData.id} style={{ backgroundColor: 'rgb(239, 68, 68)' }} place='top' positionStrategy="fixed">
                            <div className={`flex items-center`}>
                                <span className={`font-sans font-medium text-[13px]`}>Excluir Item</span>
                            </div>
                        </Tooltip>

                        <button
                            tabIndex={-1}
                            onClick={handleEditarClick} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'btn-editar-' + rowData.id}
                            className={`flex items-center justify-center 
                                        text-white transition-all duration-300 
                                        hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                        bg-sky-500 ml-2`}
                            disabled={btHabilitado}
                        >
                            <RiEdit2Fill size={'18px'} />
                        </button>
                        <Tooltip id={`tooltip-editar-${rowData.id}`} anchorSelect={'#btn-editar-' + rowData.id} style={{ backgroundColor: 'rgb(14, 165, 233)' }} place='top-end' positionStrategy="fixed">
                            <div className={`flex items-center`}>
                                <span className={`font-sans font-medium text-[13px]`}>Editar Item</span>
                            </div>
                        </Tooltip>

                    </div>
                )
            })
        },
        {
            accessorKey: 'nitem', header: 'Item', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: ({ cell }) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.nitem ? rowData.nitem : <span className={`text-red-400`}>N/D</span>}</span>)

            }

        },
        {
            accessorKey: 'descricao', header: 'Descrição', size: 500, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: ({ cell }) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.desc_prod ? rowData.desc_prod : rowData.descricao ? rowData.descricao : <span className={`text-red-400`}>N/D</span>}</span>)

            }

        },
        {
            accessorKey: 'qtd', header: 'Qtde', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: ({ cell }) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.qtd ? Funcoes.numberFormat(rowData.qtd, 'decimal', 2, 2) : <span className={`text-red-400`}>N/D</span>}</span>)

            }

        },
        {
            accessorKey: 'vl_unit', header: 'Unitário', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: ({ cell }) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.vl_unit ? Funcoes.numberFormat(rowData.vl_unit, 'decimal', 2, 2) : <span className={`text-red-400`}>N/D</span>}</span>)

            }

        },
        {
            accessorKey: 'vl_total', header: 'Total (R$)', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: ({ cell }) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.vl_tot ? Funcoes.numberFormat(rowData.vl_tot, 'currency', 2, 2) : rowData.vl_total ? Funcoes.numberFormat(rowData.vl_total, 'currency', 2, 2) : <span className={`text-red-400`}>N/D</span>}</span>)

            }

        },
        {
            accessorKey: 'aliq_icms', header: '% ICMS', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: ({ cell }) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.aliq_icms ? Funcoes.numberFormat(rowData.aliq_icms || 0, 'decimal', 2, 2) : <span className={`text-red-400`}>N/D</span>}</span>)

            }

        },
        {
            accessorKey: 'cfop', header: 'CFOP', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: ({ cell }) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cfop ? rowData.cfop : <span className={`text-red-400`}>N/D</span>}</span>)

            }

        },

    ], [btHabilitado]
    );

    const table = useMaterialReactTable({
        columns: columns,
        data: produtos,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        initialState: {
            pagination: { pageIndex: 0, pageSize: 7 },  // Define 8 elementos por página
        },
        muiPaginationProps: {
            rowsPerPageOptions: [7],  // Apenas uma opção para o seletor: 8
        },
    })

    return (
        <>
            <ThemeProvider theme={theme} >

                <MaterialReactTable table={table} />

            </ThemeProvider>

        </>
    )
})


